export default {
    'SPONSORSHIP_TEXT': "\
        <p>Nous observons depuis plusieurs années maintenant que de plus en plus de clients Secundo le sont devenus grâce au bouche à oreille.</p>\
        <p>De nombreux clients satisfaits parlent de nous à leur entourage afin qu'ils fassent appel à nos services.</p>\
        <p>Nous avons décidé de les remercier en offrant 250€ de chèques billets d'avion par client envoyé qui rejoindrait la famille Secundo.</p>\
        <p>Pour ce faire, rien de plus simple, vous nous communiquez les coordonnées de vos contacts en cliquant sur le bouton formulaire après avoir eu leur accord écrit que vous allez nous renseigner leur nom.  Ces contacts ne seront bien évidemment pas transmis à des tiers.</p>\
        <p>Merci de votre collaboration</p>\
    ",
    "RDV avocat": "Rendez-vous avocat",
    "RDV Fournisseurs": "Rendez-vous fournisseurs",
    "RDV état des lieux": "Rendez-vous état des lieux",
    "RDV check": "Rendez-vous check",
    "RDV Info": "Rendez-vous infos",
    "RDV Choix matériaux": "Rendez-vous choix matériaux",
    "Remise des clefs": "Remise des clefs"
}


// WEBPACK FOOTER //
// ./src/data/translations/fr.js